var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKlothedLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 579.6 108",
    style: {
      enableBackground: "new 0 0 579.6 108"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:var(--klothed-textColor);}\n\t.st1{clip-path:url(#SVGID_2_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M192.1,30.4c-21,0-38,17-38,38s17,38,38,38c21,0,38-17,38-38S213.1,30.4,192.1,30.4z M192.1,97.3 c-16,0-28.9-12.9-28.9-28.9s12.9-28.9,28.9-28.9c16,0,28.9,12.9,28.9,28.9S208.1,97.3,192.1,97.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.1,96.7v8.4H86.2V31.7h9.7v65H145.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,40.1h-29.5v65h-9.7v-65h-29.5v-8.4h68.7V40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.4,31.7v73.5h-9.7v-33h-49.3v33h-9.7V31.7h9.7v32.1h49.3V31.7H398.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.5,40.1v23.7h47.8v8.4h-47.8v24.5h54.4v8.4h-64.1V31.7h64.1v8.4H431.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.2,39.8v23.7H479v8.4h-47.8v24.5h54.4v8.4h-64.1V31.4h64.1v8.4H431.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M541.1,31.7h-32.4v73.5h32.4c20.3,0,36.7-16.4,36.7-36.7S561.4,31.7,541.1,31.7z M540.3,96.7h-22V40.1h22 c15.6,0,28.3,12.7,28.3,28.3S556,96.7,540.3,96.7z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "192.1,1.6 175.8,20 185.1,20 192.1,12.1 199.1,20 208.4,20  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.2,105.2 39.8,63.7 61.8,31.7 50.5,31.7 11.5,87.3 11.5,31.7 1.8,31.7 1.8,105.2 11.1,105.2 33.4,73 33.9,72.3  56.9,105.2  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlothedLogo);
export default __webpack_public_path__ + "static/media/Klothed_logo.3302a89fa3bc7311a16299ff2b234393.svg";
export { ForwardRef as ReactComponent };